/*  /frontend/src/pages/dashboard/post/components/videoEditor/constants.js
    Greatly Social – video-editor shared constants & helpers
-------------------------------------------------------------------- */

/* CloudFront domain that serves user-uploaded media */
export const CDN = 'https://files.greatlysocial.com'

/* Aspect-ratio presets shown in the crop fly-out */
export const PRESETS = [
  { id: 'keep',   label: 'Free'      },
  { id: '1:1',    label: '1 : 1'     },
  { id: '4:5',    label: '4 : 5'     },
  { id: '1.91:1', label: '1.91 : 1'  },
  { id: '2:3',    label: '2 : 3'     },
  { id: '9:16',   label: '9 : 16'    },
]

/* Map preset → numerical aspect ratio (or undefined for “Free”) */
export const aspectVal = id =>
  id === '1:1'      ? 1
: id === '4:5'      ? 4 / 5
: id === '1.91:1'   ? 1.91
: id === '2:3'      ? 2 / 3
: id === '9:16'     ? 9 / 16
: undefined           // keep / free aspect

/* ------------------------------------------------------------------ */
/* Helper: normalise any URL to CloudFront **unless** it already
   points to Shotstack (or any other non-GreatlySocial host).          */
export function toCdn (url) {
  if (!url) return url

  /* Don’t rewrite external links such as Shotstack’s output bucket */
  if (/shotstack|amazonaws/i.test(url)) return url

  try {
    // absolute or relative → URL object
    const u = new URL(url, CDN)

    /* Force hostname to CDN and strip duplicate path segment that
       Uploadcare sometimes embeds. */
    u.hostname = new URL(CDN).hostname
    u.pathname = u.pathname.replace(/^\/files\.greatlysocial\.com/, '')

    return u.href
  } catch {
    /* Fallback for plain paths */
    if (!url.startsWith('/')) url = `/${url}`
    url = url.replace(/^\/files\.greatlysocial\.com/, '')
    return `${CDN}${url}`
  }
}
